import React, { useEffect, useState } from 'react';

const ScrollTracker = ({ pageName }) => {
  const [trackedDepths, setTrackedDepths] = useState(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / documentHeight) * 100);

      // Track at 25%, 50%, 75%, and 100%
      const depths = [25, 50, 75, 100];
      
      depths.forEach(depth => {
        if (scrollPercent >= depth && !trackedDepths.has(depth)) {
          if (window.gtag) {
            window.gtag('event', 'scroll_depth', {
              'event_category': 'engagement',
              'event_label': `${pageName}_${depth}%`,
              'value': depth
            });
          }
          
          setTrackedDepths(prev => new Set([...prev, depth]));
        }
      });
    };

    // Throttle scroll events
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledHandleScroll);
    
    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [trackedDepths, pageName]);

  return null; // This component doesn't render anything
};

export default ScrollTracker;

